import { createFeatureSelector, createSelector } from '@ngrx/store';

import { subscriptionProductsEntityAdapter } from './products.state';
import {
  SUBSCRIPTION_FEATURE_KEY,
  SubscriptionState,
} from '../subscription.state';

export const selectSubscriptionState = createFeatureSelector<SubscriptionState>(
  SUBSCRIPTION_FEATURE_KEY
);

export const selectSubscriptionProductsState = createSelector(
  selectSubscriptionState,
  (state) => state.products
);

const { selectEntities, selectAll } =
  subscriptionProductsEntityAdapter.getSelectors(
    selectSubscriptionProductsState
  );

export const selectProducts = selectAll;
export const selectProductEntities = selectEntities;

export const selectIsProductsLoaded = createSelector(
  selectSubscriptionProductsState,
  (state) => state.loadStatus === 'success'
);

export const selectIsProductsLoading = createSelector(
  selectSubscriptionProductsState,
  (state) => state.loadStatus === 'loading'
);
